export default __webpack_public_path__ + "static/Retul-road-rain-ed58cd4f1e44d23393bb53fb1d898b6f.jpg";